/*
*###############################################################################
*Module Name                   : VenderMasterEmail.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Isuru Sampath Arandara                        #
*Date                          : Tuesday, August 22nd 2023, 9:31:50 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import DPDropDown from "framework/components/DPDropDown"
import DPTextBox from "framework/components/DPTextBox"
import React, { useEffect, useState } from "react"
import { getTransactions } from "./VenderControler"

import {
  Col,
  Row,
  Button,
  Table,
} from "reactstrap"
import DPSwitch from "framework/components/DPSwitch"
import ReactPaginate from "react-paginate"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"

const VenderMasterTab7 = ({
  tableData,
  setTableData,
  setAlertMsg,
  setShow,
  setAlertColor,
  disabled,
  handleNewClick
}) => {

  const [transactionType, setTransactionType] = useState("")
  const [email, setEmail] = useState("")
  const [txnList, setTxnList] = useState([])
  const [page, setPage] = useState(1)

  useEffect(async () => {
    const responseData = await getTransactions()
    setTxnList(responseData)
  }, [])


  useEffect(() => {
    setPage(1)
    setTransactionType("")
    setEmail("")
  }, [handleNewClick])


  const isValidEmail = email => {
    const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;


    return emailRegex.test(email)
  }

  const handleEmailChange = e => {
    const newEmail = e.target.value
    setEmail(newEmail)
  }

  const handleSave = () => {
    if (isValidEmail(email)) {
      const newEntry = {
        trtype: transactionType,
        email: email,
        active: true,
      }

      const hasDuplicate = tableData.some(
        entry => entry.trtype === transactionType && entry.email === email
      )


      if (!hasDuplicate) {
        setTableData([...tableData, newEntry])
        setTransactionType("")
        setEmail("")
      } else {
        setAlertColor("danger")
        setAlertMsg("Duplicate email address for this transaction type")
        setShow(true)

        setTimeout(() => {
          setShow(false)
        }, 5000)
      }
    } else {
      setAlertColor("danger")
      setAlertMsg("Invalid email format")
      setShow(true)

      setTimeout(() => {
        setShow(false)
      }, 5000)
    }
  }



  const handleDelete = index => {
    const indexOfDataToDelete = indexOfFirstPostDocument + index;
    const updatedTableData = tableData.filter((entry, i) => i !== indexOfDataToDelete);
    setTableData(updatedTableData);
  };


  const changeRowValueChanges = (value, key, element) => {
    const newObject = { ...tableData[key], [element]: value }
    setTableData(prevDataRow => {
      const newDataRow = [...prevDataRow]
      newDataRow[key] = newObject
      return newDataRow
    })
  }

  const indexOfLastPostDocument = page * 10
  const indexOfFirstPostDocument = indexOfLastPostDocument - 10
  const currentDetailRowsDocument = tableData.slice(indexOfFirstPostDocument, indexOfLastPostDocument)

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };


  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={6} className="mb-4-sm">
          <DPDropDown
            labelText={"Transaction Type"}
            optionGroup={txnList}
            selectedGroup={transactionType}
            onChange={e => {
              setTransactionType(e["value"])
            }}
            disabled={disabled}
          />
          <DPTextBox
            labelText={"Email"}
            value={email}
            onChange={handleEmailChange}
            placeholder={"Email"}
            disabled={disabled}
          />

          <Row className="d-flex flex-row-reverse">
            <Col className="d-flex flex-row-reverse">
              <Button
                onClick={handleSave}
                disabled={disabled ? true : !transactionType || !email}
                style={{ width: "80px" }}
                color="primary"
                size="sm"
              >
                Add
              </Button>
            </Col>
          </Row>
          <Row className="mt-2">
            <table>
              <thead>
                <tr>
                  <th>Transaction Type</th>
                  <th>Email</th>
                  <th className="mx-2">Active</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {currentDetailRowsDocument.map((entry, index) => (
                  <tr key={index}>
                    <td><DPTextBoxforgrid
                      value={entry.trtype}
                      disabled={true}
                    /> </td>
                    <td><DPTextBoxforgrid
                      value={entry.email}
                      disabled={true}
                    /></td>
                    <td>
                      <DPSwitch
                        rowClass="mb-4-sm"
                        textType="checkbox"
                        onChange={e => {
                          changeRowValueChanges(e, indexOfFirstPostDocument + index, "active")
                        }}
                        checked={entry.active}
                        disabled={disabled}
                      />
                    </td>
                    <td>
                      <Row className="mb-0">
                        <Col md="1">
                          <Button
                            outline
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(index)}
                            disabled={disabled}
                          >
                            <i
                              className="mdi mdi-delete"
                              style={{ fontSize: "12px" }}
                            ></i>
                          </Button>
                        </Col>
                      </Row>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Row>
          <Row className="mt-2">
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={Math.ceil(tableData.length / 10)}
              pageRangeDisplayed={1}
              onPageChange={handlePageClick}
              forcePage={page - 1}
              renderOnZeroPageCount={null}
              activeClassName={'active'}
              activeLinkClassName={'page-link'}
              containerClassName={'pagination justify-content-end pagination-sm'}
              marginPagesDisplayed={1}
            />
          </Row>
        </Col>
      </Row >
    </React.Fragment >
  )
}

export default VenderMasterTab7
